import React from 'react';
import PropTypes from 'prop-types';
import { CustomInput, Col, Row } from 'reactstrap';
import { Field } from 'react-final-form';

import FormField from 'components/Form/FormField';
import {
  required,
  mustBeNumber,
  lengthRange,
  isZip,
  composeValidators,
} from 'utils/formValidators';

const SurveyLocation = ({ values, editForm }) => (
  <React.Fragment>
    <label> Survey Location </label>
    <div className="custom-survey-container px-3 py-2">
      <Field name="locationCheckBox" type="checkbox">
        {({ input }) => {
          return (
            <div>
              <div className="custom-survey-field p-3  " fluid>
                <CustomInput id={input.name} {...input} />
                <label htmlFor={input.name} className="cursor-pointer">
                  Add a Location{' '}
                </label>
              </div>
              {values.locationCheckBox && (
                <div className="px-3">
                  <Row>
                    <Col>
                      <FormField
                        label="Address Line 1"
                        name="addressLine1"
                        containerClassName="form-group"
                        inputClassName="form-control"
                        validate={required}
                      />
                    </Col>
                    <Col>
                      <FormField
                        label="Address Line 2"
                        name="addressLine2"
                        containerClassName="form-group"
                        inputClassName="form-control"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormField
                        label="City"
                        name="city"
                        containerClassName="form-group"
                        inputClassName="form-control"
                        validate={required}
                      />
                    </Col>
                    <Col>
                      <FormField
                        label="State"
                        name="state"
                        containerClassName="form-group"
                        inputClassName="form-control"
                        validate={required}
                      />
                    </Col>
                    <Col>
                      <FormField
                        label="Zip"
                        name="zip"
                        containerClassName="form-group"
                        inputClassName="form-control"
                        validate={composeValidators(required, isZip)}
                      />
                    </Col>
                  </Row>
                  <FormField
                    label="Phone"
                    name="phone"
                    containerClassName="form-group"
                    inputClassName="form-control"
                    validate={required}
                  />
                </div>
              )}
              {editForm && (
                <FormField
                  label="Location Code"
                  name="locationCode"
                  containerClassName="form-group px-3"
                  inputClassName="form-control locationCode"
                  validate={composeValidators(
                    required,
                    mustBeNumber,
                    lengthRange(4, 6)
                  )}
                  disabled
                />
              )}
            </div>
          );
        }}
      </Field>
    </div>
  </React.Fragment>
);

SurveyLocation.propTypes = {
  values: PropTypes.shape({
    locationCheckBox: PropTypes.bool,
  }).isRequired,
};

export default SurveyLocation;



// WEBPACK FOOTER //
// ./src/components/customSurvey/FormFields/customSurveyLocation.js